// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RwvdX","question":"styles_question__3Qrns","description":"styles_description__O4KOc"};